module.exports = __webpack_public_path__ + "static/media/Phone.53173318.svg";